import { render, staticRenderFns } from "./BasicProfiling.vue?vue&type=template&id=6b933588&"
import script from "./BasicProfiling.vue?vue&type=script&lang=js&"
export * from "./BasicProfiling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports